import { z } from 'zod';

export enum CueingStepStatus {
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  NOT_STARTED = 'not_started',
  PAUSED = 'paused',
  STOPPED = 'stopped',
}

export enum LocalOnlyStepStatus {
  WAITING_FOR_ACTION = 'WAITING_FOR_ACTION',
  FOCUS_CROSS = 'FOCUS_CROSS',
}

export enum CueingStepTypeEnum {
  CUEING = 'cueing',
  VAS = 'vas',
  SONICATION_COOLDOWN = 'sonication_cooldown',
  SONICATION_RAMPUP = 'sonication_rampup',
  PAUSE = 'pause',
  NEUTRAL_CUEING = 'neutral_cueing',
}

export enum SonicationPassStatus {
  NOT_STARTED = 'not_started',
  IN_PROGRESS = 'in_progress',
  STOPPED = 'stopped',
  PAUSED = 'paused',
  COMPLETED = 'completed',
}

export const CueingStepTypeResponseSchema = z.object({
  id: z.string().uuid(),
  type: z.nativeEnum(CueingStepTypeEnum),
  name: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const CueingStepResponseSchema = z.object({
  id: z.string().uuid(),
  order: z.number(),
  status: z.nativeEnum(CueingStepStatus),
  metadata: z.record(z.unknown()),
  type: CueingStepTypeResponseSchema,
  createdAt: z.string(),
  updatedAt: z.string(),
});

export enum CueingBlockStatus {
  IN_PROGRESS = 'in_progress',
  STOPPED = 'stopped',
  RESUMED = 'resumed',
  PAUSED = 'paused',
  REPEATED = 'repeated',
  NOT_STARTED = 'not_started',
  COMPLETED = 'completed',
}

export const SonicationPassResponseSchema = z.object({
  id: z.string().uuid(),
  order: z.number(),
  status: z.nativeEnum(SonicationPassStatus),
  power: z.number(),
  time: z.number(),
  note: z.string().nullable(),
  excludedFromSonication: z.boolean(),
  targets: z.array(z.object({
    id: z.string().uuid(),
    name: z.string(),
  })),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const CueingBlockResponseSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  order: z.number(),
  status: z.nativeEnum(CueingBlockStatus),
  includesSonication: z.boolean(),
  cueingSteps: z.array(CueingStepResponseSchema),
  activeStep: CueingStepResponseSchema.nullish(),
  sonicationPasses: z.array(SonicationPassResponseSchema),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const CueingBlockListResponseSchema = z.object({
  items: z.array(CueingBlockResponseSchema),
});

export const CueingStepListResponseSchema = z.object({
  items: z.array(CueingStepResponseSchema),
});

export const SonicationPassListResponseSchema = z.object({
  items: z.array(SonicationPassResponseSchema),
});
